<template>
  <!-- 总检报告  -->
  <div v-if="model && model.generalInspection">
    <div id="print_generalInspection" class="page generalInspection-page" style="margin:0 auto; border:0px solid #E8E8EC;">
      <div style="margin-top: 10px;font-size: 18px;font-weight: 600;"><span>{{ model.generalInspection.hospitalName ? model.generalInspection.hospitalName : "" }}</span></div>
      <div style="font-size: 15px;font-weight: 600;"><span>{{ model.generalInspection.reportName ? model.generalInspection.reportName : "体检报告" }}</span></div>

      <table style="margin-top: 15px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-bottom:1px solid rgb(14, 14, 14);">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">学校：<span>{{ model.generalInspection.schoolName ? model.generalInspection.schoolName : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年级：<span>{{ model.generalInspection.gradeName ? model.generalInspection.gradeName : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">班级：<span>{{ model.generalInspection.className ? model.generalInspection.className : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">编号：<span>{{ model.generalInspection.barCode ? model.generalInspection.barCode : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">体检日期：<span>{{ model.generalInspection.physicalExaminationDate ? model.generalInspection.physicalExaminationDate : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">姓名：<span>{{ model.generalInspection.name ? model.generalInspection.name : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">性别：<span>{{ model.generalInspection.sex ? model.generalInspection.sex : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年龄：<span>{{ model.generalInspection.age ? model.generalInspection.age : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <div style="display: table;width:100%;line-height: 35px;text-align: left;">
        <div style="display: table-cell; width:50%;font-size: 15px;">
          <div style="font-size: 16px;font-weight: bold;">身高</div>
          <div style="display: table;width:100%;line-height: 25px;gap: 30px;">
            <div style="display: table-cell; width:30%;"><span>实测：</span><span>{{model.generalInspection.height ? model.generalInspection.height : ""}}</span><span> cm</span></div>
            <div style="display: table-cell; width:30%;"><span>评价：</span><span>{{model.generalInspection.heightEvaluation ? model.generalInspection.heightEvaluation : ""}}</span></div>
            <div style="display: table-cell; width:30%;"><span>标准值：</span><span>{{model.generalInspection.standardHeight ? model.generalInspection.standardHeight : ""}}</span><span> cm</span></div>
          </div>
        </div>

        <div style="display: table-cell; width:50%;font-size: 15px;">
          <div style="font-size: 16px;font-weight: bold;">体重</div>
          <div style="display: table;width:100%;line-height: 25px;gap: 30px;">
            <div style="display: table-cell; width:30%;"><span>实测：</span><span>{{model.generalInspection.weight ? model.generalInspection.weight : ""}}</span><span> kg</span></div>
            <div style="display: table-cell; width:30%;"><span>评价：</span><span>{{model.generalInspection.weightEvaluation ? model.generalInspection.weightEvaluation : ""}}</span></div>
            <div style="display: table-cell; width:30%;"><span>标准值：</span><span>{{model.generalInspection.standardWeight ? model.generalInspection.standardWeight : ""}}</span><span> kg</span></div>
          </div>
        </div>
      </div>

      <div style="display: table;width:100%;text-align: center;margin-top: 10px;">
        <div style="display: table-cell; width:50%;margin-left: 30px;">
          <div style="display: -webkit-box;display: -ms-flexbox;display: flex;margin-left: 120px;padding: 5px 0;font-size: 14px;">
            <div style="padding: 0 3px;color: rgb(91, 120, 221);"><span class="blue" style="padding: 0px 7px;background: rgb(250, 179, 63);margin: 0 3px;"></span>实测身高</div>
            <div style="padding: 0 3px;color: rgb(91, 120, 221);"><span class="yellow" style="padding: 0px 7px;background: rgb(63, 139, 239);margin: 0 3px;"></span>标准身高</div>
          </div>
          <div id="heightChart" style="text-align: center;width: 380px;height: 180px;margin-left: 30px;"/>
        </div>
        <div style="display: table-cell; width:50%;margin-left: 30px;">
          <div class="typeTip" style="display: -webkit-box;display: -ms-flexbox;display: flex;margin-left: 120px;padding: 5px 0;font-size: 14px;">
            <div style="padding: 0 3px;color: rgb(91, 120, 221);"><span class="blue" style="padding: 0px 7px;background: rgb(250, 179, 63);margin: 0 3px;"></span>实测体重</div>
            <div style="padding: 0 3px;color: rgb(91, 120, 221);"><span class="yellow" style="padding: 0px 7px;background: rgb(63, 139, 239);margin: 0 3px;"></span>标准体重</div>
          </div>
          <div id="weightChart" style="text-align: center;width: 380px;height: 180px;margin-left: 30px;"/>
        </div>
      </div>

      <div style="padding: 8px 0px;border-bottom: 1px solid rgb(240, 239, 247);text-align: center;margin-top: 5px;">
        体格发育评价：<span style="color: rgb(244, 78, 74);"></span><span>{{ model.generalInspection.physicalDevelopmentEvaluation }}</span>
      </div>
      <div style="margin-top:15px;display: table;width:100%;text-align: center;">
        <div style="display: table-cell; width:50%;margin-left: 50px;">
          <div style="margin-top: 10px;margin-bottom: 10px;">身高发育监视图（cm）</div>
          <div id="heightLineChart" style="text-align: center;width: 320px;height: 300px;"/>
        </div>
        <div style="display: table-cell; width:50%;margin-left: 50px;">
          <div style="margin-top: 10px;margin-bottom: 10px;">体重发育监视图（kg）</div>
          <div id="weightLineChart" style="text-align: center;width: 320px;height: 300px;"/>
        </div>
      </div>

      <table style="margin-top: 10px;width: 100%;border-collapse: collapse;border:none;border-top:1px solid #0E0E0EFF;">
        <tbody>
          <tr style="text-align: left;line-height: 60px;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 18px;font-weight: bold;">医生建议</p></div>
              <div v-if="!model.generalInspection.adviceProgrammes || model.generalInspection.adviceProgrammes.length == 0">未见异常</div>
              <div v-for="(item, index) in model.generalInspection.adviceProgrammes">
                <div style="font-size: 16px;">{{ item.title }}</div>
                <div style="line-height: 18px;">{{ item.content }}</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>

import {_generalInspection} from "@/services/report/report";
export default {
  name: "generalInspectionReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        generalInspection:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'generalInspection'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'generalInspection') {
          this.model = newVal;
          this.initGeneralInspectionChart();
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods:{
    loadData(){
      if(this.barCode){
        this.generalInspection(this.barCode);
      }
    },
    generalInspection(barCode) {
      _generalInspection({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        this.initGeneralInspectionChart();
      })
    },
    loadGeneralInspectionScript() {
      return new Promise((resolve, reject) => {
        if (window.echarts) return resolve();
        /*
        if (document.querySelector(`script[src="/loadScript/echarts.min.js"]`)) return resolve();
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/echarts@latest/dist/echarts.min.js';
        script.onload = resolve;
        */

        const script = document.createElement('script');
        script.src = `/loadScript/echarts.min.js?v=${Date.now()}`; // 指向 public 目录
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    async initGeneralInspectionChart() {
      await this.loadGeneralInspectionScript(); // 确保脚本加载完成
      this.heightEcharts();
      this.weightEcharts();
      this.heightLineEcharts();
      this.weightLineEcharts();
    },
    heightEcharts(){
      let chart = document.getElementById('heightChart');
      let heightChart = echarts.init(chart, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });

      if (this.model && this.model.generalInspection && this.model.generalInspection.heightHistogram) {
        this.model.generalInspection.heightHistogram[0] = this.model.generalInspection.heightHistogram[0] || '';
        this.model.generalInspection.heightHistogram[1] = this.model.generalInspection.heightHistogram[1] || '';
      } else {
        this.model.generalInspection.heightHistogram = [];
      }

      let option = {
        /*title: {
          text: '',
        },*/
        animation: false,
        // 关闭动画，否则动画效果影响打印
        legend: {
          show: true,
          data: ['实测身高', '标准身高'],
        },
        xAxis: {
          type: 'category',
          data: [this.model.generalInspection && this.model.generalInspection.heightHistogram && this.model.generalInspection.heightHistogram[0] ? this.model.generalInspection.heightHistogram[0] : '', this.model.generalInspection && this.model.generalInspection.heightHistogram && this.model.generalInspection.heightHistogram[1] ? this.model.generalInspection.heightHistogram[1] : '']
        },
        yAxis: {
          type: 'value',
          name: '单位(cm)',
          nameTextStyle: {
            //y轴上方单位的颜色
            color: 'rgb(91, 120, 221)'
          }
        },
        grid: {
          //与绝对定位相似，top，left，right，bottom 设定是根据上级盒子宽高来计算
          top: "30%",
          left: "15%",
          right: "15%",
          bottom: "20%"
        },
        series: [{
          data: [{
            value: this.model.generalInspection && this.model.generalInspection.heightHistogram ? this.model.generalInspection.heightHistogram[0] : '',
            itemStyle: {
              color: 'rgb(250, 179, 63)'
            }
          }, {
            value: this.model.generalInspection && this.model.generalInspection.heightHistogram && this.model.generalInspection.heightHistogram.length > 1 && this.model.generalInspection.heightHistogram[1] ? this.model.generalInspection.heightHistogram[1] : '',
            itemStyle: {
              color: 'rgb(63, 139, 239)'
            }
          }],
          type: 'bar',
          barWidth: 20
        }]
      };

      if (option && typeof option === 'object') {
        heightChart.setOption(option);
      }
      window.addEventListener('resize', heightChart.resize);
    },
    weightEcharts(){
      let chart = document.getElementById('weightChart');
      let weightChart = echarts.init(chart, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });

      if (this.model && this.model.generalInspection && this.model.generalInspection.weightHistogram) {
        this.model.generalInspection.weightHistogram[0] = this.model.generalInspection.weightHistogram[0] || '';
        this.model.generalInspection.weightHistogram[1] = this.model.generalInspection.weightHistogram[1] || '';
      } else {
        this.model.generalInspection.weightHistogram = [];
      }

      let option = {
        /*title: {
          text: '',
        },*/
        animation: false,
        // 关闭动画，否则动画效果影响打印
        legend: {
          data: ['实测体重', '标准体重'],
          orient: 'horizontal',
        },
        xAxis: {
          type: 'category',
          data: [this.model.generalInspection && this.model.generalInspection.weightHistogram && this.model.generalInspection.weightHistogram[0] ? this.model.generalInspection.weightHistogram[0] : '', this.model.generalInspection && this.model.generalInspection.weightHistogram && this.model.generalInspection.weightHistogram[1] ? this.model.generalInspection.weightHistogram[1] : '']
        },
        yAxis: {
          type: 'value',
          name: '单位(kg)',
          nameTextStyle: {
            //y轴上方单位的颜色
            color: 'rgb(91, 120, 221)',
            fontsize: 16
          }
        },
        grid: {
          //与绝对定位相似，top，left，right，bottom 设定是根据上级盒子宽高来计算
          top: "30%",
          left: "15%",
          right: "15%",
          bottom: "20%"
        },
        series: [{
          data: [{
            value: this.model.generalInspection && this.model.generalInspection.weightHistogram ? this.model.generalInspection.weightHistogram[0] : '',
            itemStyle: {
              color: 'rgb(250, 179, 63)'
            }
          }, {
            value: this.model.generalInspection && this.model.generalInspection.weightHistogram && this.model.generalInspection.weightHistogram.length > 1 && this.model.generalInspection.weightHistogram[1] > 0 ? this.model.generalInspection.weightHistogram[1] : '',
            itemStyle: {
              color: 'rgb(63, 139, 239)'
            }
          }],
          type: 'bar',
          barWidth: 20
        }]
      };
      if (option && typeof option === 'object') {
        weightChart.setOption(option);
      }
      window.addEventListener('resize', weightChart.resize);
    },
    heightLineEcharts(){
      let chart = document.getElementById('heightLineChart');
      let heightLineChart = echarts.init(chart, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });

      let option = {
        title: {
          // text: '身高发育监视图（cm）',
          // left: 'center',
          // textStyle: { color: '#5b78dd', fontSize: 14 }
        },
        animation: false,
        /*tooltip: {
          trigger: 'axis'
        },*/
        legend: {
          data: ['-2SD', 'X', '+1SD', '+2SD', '-1SD', '实测值'],
          orient: 'horizontal',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: false
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              // type:'solid',
              // color:'#000'
            }
          },
          data:this.model.generalInspection.heightMonthAge
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '-2SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(255,131,133)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.heightDown2sd,
          },
          {
            name: 'X',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(97,125,222)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.heightMedian,
          },
          {
            name: '+1SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(254,224,192)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.heightUp1sd,
          },
          {
            name: '+2SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(255,195,196)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.heightUp2sd,
          },
          {
            name: '-1SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(48,202,154)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.heightDown1sd,
          },
          {
            name: '实测值',
            type: 'line',
            symbol: 'circle',
            showAllSymbol: true,
            symbolSize: 8,
            itemStyle: {
              normal: {
                // label: {show: true},
                color: 'rgb(54,60,84)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.heightMeasuredValue,
          },

        ]
      }
      if (option && typeof option === 'object') {
        heightLineChart.setOption(option);
      }
      window.addEventListener('resize', heightLineChart.resize);
    },
    weightLineEcharts(){
      let chart = document.getElementById('weightLineChart');
      let weightLineChart = echarts.init(chart, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });

      let option = {
        title: {
          // text: '体重发育监视图（kg）',
          // left: 'center',
          // textStyle: { color: '#5b78dd', fontSize: 14 }
        },
        animation: false,
        /*tooltip: {
          trigger: 'axis'
        },*/
        legend: {
          data: ['-2SD', 'X', '+1SD', '+2SD', '-1SD', '实测值'],
          orient: 'horizontal',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: false
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              // type:'solid',
              // color:'#000'
            }
          },
          data:this.model.generalInspection.weightMonthAge
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '-2SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(255,131,133)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.weightDown2sd,
          },
          {
            name: 'X',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(97,125,222)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.weightMedian,
          },
          {
            name: '+1SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(254,224,192)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.weightUp1sd,
          },
          {
            name: '+2SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(255,195,196)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.weightUp2sd,
          },
          {
            name: '-1SD',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(48,202,154)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.weightDown1sd,
          },
          {
            name: '实测值',
            type: 'line',
            symbol: 'circle',
            showAllSymbol: true,
            symbolSize: 8,
            itemStyle: {
              normal: {
                // label: {show: true},
                color: 'rgb(54,60,84)' //折线图与小圆点颜色
              }
            },
            data:this.model.generalInspection.weightMeasuredValue,
          },

        ]
      }

      if (option && typeof option === 'object') {
        weightLineChart.setOption(option);
      }
      window.addEventListener('resize', weightLineChart.resize);
    },

  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .generalInspection-page {
    page: generalInspection-page; /* 绑定唯一命名 */
  }
  @page generalInspection-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:30px;padding-right:30px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}


</style>
